export const moreActionKeys = {
  share: "Share",
  edit: "Edit",
  delete: "Delete",
  viewTransactions: "View Transactions",
  endOffer: "End Offer",
};

export const limited_time_offer_statuses = {
  scheduled: 0,
  active: 1,
  expired: 2,
};

export const limited_time_offer_statuses_data = {
  [limited_time_offer_statuses.scheduled]: {
    label: "Scheduled",
  },
  [limited_time_offer_statuses.active]: {
    label: "Active",
  },
  [limited_time_offer_statuses.expired]: {
    label: "Expired",
  },
};

export const LIMITED_TIME_OFFER_LEARN_MORE_HREF = {
  LTO: "https://support.exlyapp.com/support/solutions/articles/84000347854-limited-time-offers-on-exly",
  LTO_VIDEO: "https://www.youtube-nocookie.com/embed/fz_X0fqS1KQ",
};

export const STAT_CARDS = {
  VIEWS: {
    title: "Total Visitors",
  },
  LEADS: {
    title: "Total Leads",
  },
  BOOKINGS: {
    title: "Total Bookings",
  },
  REVENUE: {
    title: "Total Revenue",
  },
};

export const date_range_select_options = {
  last_7: { value: "last_7", label: "Last 7 days", days: 7 },
  last_30: { value: "last_30", label: "Last 30 days", days: 30 },
  lifetime: { value: "last_365", label: "Last 1 year", days: 365 },
  custom: { value: "custom", label: "Custom" },
};

export const AVATAR_COLORS = [
  { bg: "#FCE4EC", text: "#C2185B" }, // Pink
  { bg: "#E8F5E9", text: "#2E7D32" }, // Green
  { bg: "#E3F2FD", text: "#1565C0" }, // Blue
  { bg: "#FFF3E0", text: "#EF6C00" }, // Orange
  { bg: "#F3E5F5", text: "#7B1FA2" }, // Purple
  { bg: "#E0F7FA", text: "#00838F" }, // Cyan
];

export const getAudienceFilterConfig = (isWhatsApp = false) => [
  {
    source: "name",
    placeholder: "Recipient name",
    type: "input",
  },
  isWhatsApp
    ? {
        source: "phone_number",
        placeholder: "Phone number",
        type: "input",
      }
    : {
        source: "email",
        placeholder: "Email ID",
        type: "input",
      },
];

export const audienceFilterConfig = getAudienceFilterConfig(false);

export const STATISTICS_TYPE_MAP = {
  attempted_for: "attempted",
  sent_to: "sent",
  delivered_to: "delivered",
  failed_for: "failed",
  opened_by: "opened",
  replied_by: "replied",
};

export const U_LETTER = "U";
export const DEFAULT_USER = "Unknown";
export const LTO_STATS = "ltoStats";
